import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS,  } from "./api-base"
import { getESGReqHeader } from "./tool-service";

export const queryMemberFunctionList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010401'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010401")}`, method: 'post', data: ReqBody })
}

export const updateMemberFunctionList = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('B2010402'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("B2010402")}`, method: 'post', data: ReqBody })
}
